import { useRef, useState } from "react";
import Indexdasbord from "../../../composant/navbar/indexDashbord";
import cameraIcon from "../../../image/cameraIcon.png";
import { Box, Button } from "@mui/material";
import imageCompression from "browser-image-compression";
import heic2any from "heic2any";
import { useSelector } from "react-redux";
import ImageCard from "../../../composant/imageGallery/ImageGallrey";
import { Api_Token } from "../../../env";
import axios from "axios";

export default function PageTakeImage() {
  return <Indexdasbord Children={<TakeImage />} />;
}

function TakeImage() {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const cameraInputRef = useRef(null);
  const { user } = useSelector((state) => state.Auth);
  const [numberImpresssion, setNumberImpression] = useState(1);

  const handleOpenCamera = () => {
    cameraInputRef.current.click();
  };

  async function AddImage(e) {
    setLoading(true);
    const file = e.target.files[0];
    if (!file) return;

    try {
      let convertedFile = file;

      // تحويل HEIC إلى JPG إن لزم
      if (file.type === "image/heic" || file.name.endsWith(".heic")) {
        const blob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.8,
        });
        convertedFile = new File(
          [blob],
          file.name.replace(/\.heic$/i, ".jpg"),
          {
            type: "image/jpeg",
          }
        );
      }

      // ضغط الصورة
      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(convertedFile, options);

      const imageUrl = URL.createObjectURL(compressedFile);
      setImage({ file: compressedFile, url: imageUrl });
    } catch (err) {
      console.error("Erreur lors de l'ajout de l'image :", err);
      alert("Une erreur s'est produite lors du traitement de l'image.");
    } finally {
      setLoading(false);
    }
  }
  const sendToPrint = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://192.168.1.4:5001/print_images",
        data
      );
      if (response.status === 200 || response.status === 207) {
        const results = response.data.results;
        const allPrintedSuccessfully = results.every(
          (result) => result.message === "Image printed successfully"
        );

        if (allPrintedSuccessfully) {
          //setOpenPopup(true);

          setLoading(false);
        } else {
          setLoading(false);
          console.error("Some images failed to print");
        }
        Api_Token.post(`command/editPriceCommand`, {
          idCommand: data.commandId,
          numberImageImprime: response.data.total_printed,
        });
      } else {
        console.error("Failed to send images. Status code:", response.status);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error sending images:", error);
    }
  };

  const handlePrint = async () => {
    if (!image) return;

    const formData = new FormData();
    formData.append("image", image.file);
    formData.append("count", numberImpresssion); // عدد النسخ
    formData.append("idproduit", user.Event.idProduit); // إذا احتجت إرسال معرف المستخدم

    try {
      const response = await Api_Token.post(
        "/command/AddCommandEvent",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        alert("Image envoyée avec succès pour impression.");
        sendToPrint(response.data);
      } else {
        alert("Échec de l'envoi de l'image.");
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi au serveur :", error);
      alert("Une erreur s'est produite lors de l'envoi au serveur.");
    }
  };

  const handleDelete = () => {
    setImage(null);
    setNumberImpression(1);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={2}>
      <input
        type="file"
        ref={cameraInputRef}
        style={{ display: "none" }}
        accept="image/*"
        capture="environment"
        onChange={AddImage}
      />

      {!image && (
        <img
          src={cameraIcon}
          onClick={handleOpenCamera}
          alt="Open camera"
          style={{
            height: "80px",
            width: "80px",
            objectFit: "contain",
            cursor: "pointer",
            marginBottom: "16px",
          }}
        />
      )}

      {loading && <p>Chargement de l'image...</p>}

      {image && (
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <ImageCard
            src={image.url}
            onDelete={handleDelete}
            type={user.Event.Produit.NomProduit}
            badgeContent={numberImpresssion}
            //  index={index}
            handleCountChange={(index, number) =>
              setNumberImpression((prev) => prev + number)
            }
            plusMarge={true}
          />
          <Box display="flex" gap={2}>
            <Button variant="contained" color="primary" onClick={handlePrint}>
              Imprimer
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}
